import { EMableEventName } from '@/core/constants/event_types/events';

import { AEventTrigger } from '..';

export type CustomerDataDetectWtagInput = {
  email: string[];
  firstName: string[];
  lastName: string[];
  phone: string[];
};

type CustomerDataMap = Record<string, string[]>;

export class AbstractLeadFormEventTrigger extends AEventTrigger {
  eventName: EMableEventName = EMableEventName.LEAD;

  static customerDataMap: CustomerDataMap =
    AbstractLeadFormEventTrigger.generateCustomerDataMap();

  static generateCustomerDataMap(): CustomerDataMap {
    const keywords = ['email', 'firstName', 'lastName', 'phone', 'tel'];
    const customerDataMap: CustomerDataMap = {};

    keywords.forEach(keyword => {
      customerDataMap[keyword] = [
        `input[type=${keyword}]`,
        `input[name*=${keyword}]`,
        `input[id*=${keyword}]`,
        `input[class*=${keyword}]`,
        `input[placeholder*=${keyword}]`,
      ];
    });

    return customerDataMap;
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  handleEventTriggered = <CustomerDataDetectWtagInput>(
    customerInfo: CustomerDataDetectWtagInput,
    ds: string,
  ) => {
    // const customerInfoNew: {
    const customerInfoNew: {
      email: string[];
      firstName: string[];
      lastName: string[];
      phone: string[];
    } = customerInfo as {
      email: string[];
      firstName: string[];
      lastName: string[];
      phone: string[];
    };
    if (
      customerInfoNew.email.length > 0 ||
      customerInfoNew.firstName.length > 0 ||
      customerInfoNew.lastName.length > 0 ||
      customerInfoNew.phone.length > 0
    ) {
      this.wtagFunction('event', this.eventName, {
        cdas: [
          {
            ds,
            em: customerInfoNew.email[0] || '',
            fn: customerInfoNew.firstName[0] || '',
            ln: customerInfoNew.lastName[0] || '',
            ph: customerInfoNew.phone[0] || '',
          },
        ],
        eventData: {},
      });
    }
  };

  override registerEvent(): void {
    throw new Error('Method not implemented.');
  }
}
